document.addEventListener("DOMContentLoaded", function () {
   
  function update_inveterate_price_widget(priceElement){
    setTimeout(function () { // Delay to ensure DOM is fully loaded
        //let priceElement = document.querySelector(".stayPrice");

        if (priceElement) {
            let originalPriceText = "";
            let originalPrice = 0;
            let currencySymbol = "$"; // Default symbol if not detected

            // Find all text content inside .stayPrice and remove <s> if present
            let strikethroughPrice = priceElement.querySelector("s");

            if (strikethroughPrice) {
                // If <s> exists, use its text content (original price)
                originalPriceText = strikethroughPrice.textContent.trim();
            } else {
                // If no <s> exists, use full text (trim spaces)
                originalPriceText = priceElement.innerText.trim();
            }

            // Extract the currency symbol dynamically (first non-numeric character before numbers)
            let currencyMatch = originalPriceText.match(/[^0-9.,]+/);
            if (currencyMatch) {
                currencySymbol = currencyMatch[0].trim(); // Assign detected currency symbol
            }

            // Extract the numeric value properly to avoid NaN in Safari
            let numericMatch = originalPriceText.match(/[0-9]+(\.[0-9]{1,2})?/);
            if (numericMatch) {
                originalPrice = parseFloat(numericMatch[0]); // Convert matched number to float
            }

            // Ensure price is valid before proceeding
            if (!isNaN(originalPrice) && originalPrice > 0) {
                // Calculate the 10% discounted price
                let discountedPrice = (originalPrice * 0.90).toFixed(2);

                // Build the new HTML structure
                let newHtml = `<div class="new-price-container">
                                    <div class="reg-price">Regular Price: ${currencySymbol}${originalPrice.toFixed(2)}</div>
                                    <div class="insider-price">Member Price: ${currencySymbol}${discountedPrice}</div>
                               </div>`;

                // Convert the new HTML string into actual HTML elements
                let tempDiv = document.createElement("div");
                tempDiv.innerHTML = newHtml;
                let newElement = tempDiv.firstChild;

                // Find the upsell button and insert the new HTML above it
                let upsellButton = document.querySelector(".inveterate-upsell__button");
                if (upsellButton) {
                    upsellButton.parentNode.insertBefore(newElement, upsellButton);
                }

                // Convert the new HTML string into actual HTML elements
                let tempDiv2 = document.createElement("div");
                tempDiv2.innerHTML = newHtml;
                let newElement2 = tempDiv2.firstChild;

                // Find the upsell copy and insert the new HTML above it
                let upsellCopy = document.querySelector(".inveterate-upsell__copy");
                if (upsellCopy) {
                    upsellCopy.parentNode.insertBefore(newElement2, upsellCopy);
                }
            }
        }
    }, 100); // Small delay ensures DOM is fully loaded before running
  }

  const stayPriceElement = document.querySelector(".stayPrice");
  const salePriceElement = document.querySelector(".price-item.price-item--sale");
  
  if (stayPriceElement && stayPriceElement.textContent.trim() !== "") {
    console.log('++++++++++++++++++++++++++++++++stayPriceElement');
    update_inveterate_price_widget(stayPriceElement);
  } else if (salePriceElement) {
    console.log('++++++++++++++++++++++++++++++++salePriceElement');
    update_inveterate_price_widget(salePriceElement);
  }else{
    console.log('++++++++++++++++++++++++++++++++else');
  }
    
});


document.addEventListener("DOMContentLoaded", function() {
    let priceElement = document.querySelector(".inveterate-upsell__product__info__price");
    if (priceElement) {
        priceElement.innerHTML = priceElement.innerHTML.trim() + " - billed annually";
    }
});
